/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_SheetInputs */

const en_vc_shots_sheet = /** @type {(inputs: Vc_Shots_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple artboards in VectorCraft showing Pathfinder, Gradient Mesh, Repeat and Envelope Distort`)
};

const zh_vc_shots_sheet = /** @type {(inputs: Vc_Shots_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 多画板：路径查找器、渐变网格、重复和封套扭曲`)
};

/**
* | output |
* | --- |
* | "Multiple artboards in VectorCraft showing Pathfinder, Gradient Mesh, Repeat and Envelope Distort" |
*
* @param {Vc_Shots_SheetInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_sheet = /** @type {((inputs?: Vc_Shots_SheetInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_SheetInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_sheet(inputs)
	return zh_vc_shots_sheet(inputs)
});
export { vc_shots_sheet as "vc.shots.sheet" }